import React, { useState } from "react";
import { MdMoreVert } from "react-icons/md";
import { Button, Popover, Row, Col, Divider,  } from "antd";
import LinkSettingsModal from "routes/SourceWiz/CreateCollection/LinkSettings/LinkSettingsModal";
import styled from "styled-components";
import {
  MdLink,
  MdKeyboardArrowRight,
  MdSecurity,
  
  MdContentCopy,
  MdDelete,
} from "react-icons/md";
import Can from "../../../../../casl/Can";
import { PERMISSIONS } from "constants/permissions";


const StyledMenuItem = styled(Row)`
padding: 5px;
&:hover {
  background-color: #F5F5F5;
  
  
}
`


const MenuItem = ({ primaryIcon, secondaryIcon, title, text, onClick }) => (
  <>
    <StyledMenuItem  className="more-options-menu-item"  onClick={() => onClick()}>
      <Col span={24} >
        <Row align="middle">
          <Col span={2} style={{ paddingTop: 5 }}>
            {primaryIcon}
          </Col>
          <Col span={20}>
            <strong className="menu-item-title" style={{ marginTitleottom: 4 }}>
              {title}
            </strong>
          </Col>
          <Col span={2}>{secondaryIcon}</Col>
        </Row>
        <Row style={{ marginTop: -5 }}>
          <Col offset={2} span={20}>
            <span className="menu-item-subtitle" type="secondary">
              {text}
            </span>
          </Col>
        </Row>
      </Col>
    </StyledMenuItem>
  </>
);

export default function MoreOptions({
  text,
  row,
  // deactivateCatalogue,
  // deleteCatalogue,
  activateCatalogue,
  showModal,
  linkSecurityData,
  handleUpdateLinkSecurityData,
}) {
  const [showLinkSettingsModal, toggleLinkSettingsModal] = useState(false);
  const [reactivateLinkSettings, setReactivateLinkSettings] = useState(false);
  // active menu items

  const handleModal = (value) => {
    toggleLinkSettingsModal(value);
    if (reactivateLinkSettings) setReactivateLinkSettings(false);
  };

  const activeMenu = (
    <div style={{ borderRadius: 4, maxWidth:"30em" }}>
      {/* Deactivate  catalogue*/}
    
         <Can
         I={PERMISSIONS.update_catalogues_link_security.slug}
         a={PERMISSIONS.update_catalogues_link_security.permissionType}
       >
        <MenuItem
          primaryIcon={<MdLink size={22} />}
          secondaryIcon={<MdKeyboardArrowRight size={22} />}
          title="Deactivate catalogue link"
          text="Link will be deactivated and you can activate it again later"
          onClick={() => {
            // deactivateCatalogue(text?.id);
            showModal("deactivate", text?.id);
          }}
        />
      
      
      </Can>

      {/* Update link settings */}
      {/* <MenuItem
        primaryIcon={<MdSecurity size={22} />}
        secondaryIcon={<MdKeyboardArrowRight size={22} />}
        title="Update link settings"
        text="Change settings for password security and expiry date"
        onClick={() => {}}
      />
        */}
      {/* Change PPT Template */}
      {/* 
      <MenuItem
        primaryIcon={<MdDashboard size={22} />}
        secondaryIcon={<MdKeyboardArrowRight size={22} />}
        title="Change PPT Template"
        text="Set the template of the PPT when buyer downlaods from link"
        onClick={() => {}}
      />
        */}

      {/* Create a copy of this catalogue */}

     {/* //casl starts here  */}
    <Can
      I={PERMISSIONS.update_catalogues_link_security.slug}
      a={PERMISSIONS.update_catalogues_link_security.permissionType}
    >
      {(allowed) => (
      
      <MenuItem
        primaryIcon={<MdSecurity size={25} />}
        secondaryIcon={<MdKeyboardArrowRight size={25} />}
        title="Update link settings"
        text="Change settings for password security and expiry date"
        onClick={() => {
          toggleLinkSettingsModal(true);
        }}
      />

     
      )}
    </Can>
  {/* //casl ends here  */}

        <Can I={PERMISSIONS.create_catalogues.slug} a={PERMISSIONS.create_catalogues.permissionType}>
        
            <MenuItem
              primaryIcon={<MdContentCopy size={22} />}
              secondaryIcon={<MdKeyboardArrowRight size={22} />}
              title="Create a copy of this catalogue"
              text="A copy of this catalogue will be created with same products"
              onClick={() => {
                showModal("copy", text?.id, text);
              }}
            />
      </Can>
     

      {/* Delete catalogue */}
      <Can I={PERMISSIONS.delete_catalogues.slug} a={PERMISSIONS.delete_catalogues.permissionType}>
      
      <MenuItem
        primaryIcon={<MdDelete size={22} />}
        secondaryIcon={<MdKeyboardArrowRight size={22} />}
        title="Delete catalogue"
        text="Permanantly delete this catalogue. You cannot restore them later"
        onClick={() => {
          // deleteCatalogue(text?.id);
          showModal("delete", text?.id);
        }}
      />
      </Can>
    </div>
  );
  // inactive menu items
  const inActiveMenu = (
    <div style={{ borderRadius: 4, maxWidth:"30em" }}>
      {/* Create a copy of this catalogue */}

      <Can I={PERMISSIONS.update_catalogues_link_security.slug} a={PERMISSIONS.update_catalogues_link_security.permissionType}>

      <MenuItem
        primaryIcon={<MdLink size={25} />}
        secondaryIcon={<MdKeyboardArrowRight size={25} />}
        title="Activate catalogue link"
        text="Link will be activated and you can deactivate it again later"
        onClick={() => {
          // showModal("activate", text?.id);
          // activateCatalogue(text?.id);
          toggleLinkSettingsModal(true);
          setReactivateLinkSettings(true);
        }}
      />
      </Can>
     
      <Can I={PERMISSIONS.create_catalogues.slug} a={PERMISSIONS.create_catalogues.permissionType}>
      
      <MenuItem
        primaryIcon={<MdContentCopy size={22} />}
        secondaryIcon={<MdKeyboardArrowRight size={22} />}
        title="Create a copy of this catalogue"
        text="A copy of this catalogue will be created with same products"
        onClick={() => {
          showModal("copy", text?.id, text);
        }}
      />
      </Can>  
   

      {/* Delete catalogue */}

     <Can I={PERMISSIONS.delete_catalogues.slug} a={PERMISSIONS.delete_catalogues.permissionType}>
     
     <MenuItem
        primaryIcon={<MdDelete size={22} />}
        secondaryIcon={<MdKeyboardArrowRight size={22} />}
        title="Delete catalogue"
        text="Permanantly delete this catalogue. You cannot restore them later"
        onClick={() => showModal("delete", text?.id)}
      />
      </Can>
    </div>
  );

  // draft menu items
  const dreatMenu = (
    <div style={{ borderRadius: 4, maxWidth:"30em" }}>
      {/* Create a copy of this catalogue */}
      <Can I={PERMISSIONS.create_catalogues.slug} a={PERMISSIONS.create_catalogues.permissionType}>
      <MenuItem
        primaryIcon={<MdContentCopy size={22} color="#686E6D" />}
        secondaryIcon={<MdKeyboardArrowRight size={22} color="#686E6D" />}
        title="Create a copy of this catalogue"
        text="A copy of this catalogue will be created with same products"
        onClick={() => {
          showModal("copy", text?.id, text);
        }}
      />
      
    </Can>
     

      {/* Delete catalogue */}
      <Can I={PERMISSIONS.delete_catalogues.slug} a={PERMISSIONS.delete_catalogues.permissionType}>
      
      <MenuItem
        primaryIcon={<MdDelete size={22} color="#686E6D" />}
        secondaryIcon={<MdKeyboardArrowRight size={22} color="#686E6D" />}
        title="Delete catalogue"
        text="Permanantly delete this catalogue. You cannot restore them later"
        onClick={() => showModal("delete", text?.id)}
      />
      </Can>
    </div>
  );


  // condition for menu items
  const content = (status) => {
    let menuObj = {
      published: activeMenu,
      inactive: inActiveMenu,
      dreat: dreatMenu,
    };
    return menuObj[status] || dreatMenu;
  };

  return (
    <>
      <Popover
        placement="bottomLeft"
        content={content(row?.status)}
        trigger="hover"
      >
        <Button
          size="large"
          type="default"
          className="table-control"
          icon={<MdMoreVert size={25} />}
        ></Button>
      </Popover>
      {showLinkSettingsModal && (
        <LinkSettingsModal
          handleUpdate={handleUpdateLinkSecurityData}
          collectionLink={row?.controls?.collection_link}
          collectionId={row?.controls?.id}
          collectionName={row?.controls?.collection_name}
          linkSecurityData={linkSecurityData}
          visible={showLinkSettingsModal}
          toggleModal={handleModal}
          reactivateLinkSettings={reactivateLinkSettings}
          activateCatalogue={activateCatalogue}
        />
      )}
    </>
  );
}
